import { Suggestion } from './../../../shared/models/suggestion';
import { Component, OnInit, Input, OnChanges, ViewChild } from '@angular/core';
import { Investor } from '../../../shared/models/investor';
import { availableGroupings } from '../../asset-allocation/asset-allocation.component';
import { DoughnutChartItem } from '../../../shared/components/doughnut-chart/dought-item';
import { groupBy } from 'underscore';
import { DoughnutChartjsComponent } from '../../../shared/components/doughnut-chartjs/doughnut-chartjs.component';
import { SuggestionDataService } from './../../../../services/suggestion-data.service';
import { CategoryDataService } from '../../../../services/category-data.service';

@Component({
  selector: 'app-suggest',
  templateUrl: './suggest.component.html',
  styleUrls: ['./suggest.component.css'],
})

export class SuggestComponent implements OnInit, OnChanges {
  constructor(private __suggestionService: SuggestionDataService, private __categoryService: CategoryDataService) { }
  @Input() investor: Investor;
  @Input() category: string;
  @Input() new_risk_category: string;

  @ViewChild('advisorChart')
  advisorChart: DoughnutChartjsComponent;

  unit = "%";
  chartData = [];
  selectedChartData = [];
  advisorChartData = [];
  assetGroups = availableGroupings;
  _total = 0;
  categoryData: Object;
  suggestionData: any[] = [];
  suggestionTotal = 0;
  currentReturn = 0;
  maxValues = {};

  basic: Object;
  standard: Object;
  premium: Object;

  ngOnInit() {
    this.__categoryService.getCategoryByKey('basic').get()
      .then((value) => {
        this.basic = JSON.parse(value.data().data);
        if (this.category == 'basic') {
          this.categoryData = this.basic;
          this.calculateMax();
          Object.assign(this.suggestionData, this.categoryData[this.new_risk_category].values);
          this.processData();
        }
      });
    this.__categoryService.getCategoryByKey('standard').get()
      .then((value) => {
        this.standard = JSON.parse(value.data().data);
        if (this.category == 'standard') {
          this.categoryData = this.standard;
          Object.assign(this.suggestionData, this.categoryData[this.new_risk_category].values);
          this.calculateMax();
          this.processData();
        }
      });
    this.__categoryService.getCategoryByKey('premium').get()
      .then((value) => {
        this.premium = JSON.parse(value.data().data);
        if (this.category == 'premium') {
          this.categoryData = this.premium;
          Object.assign(this.suggestionData, this.categoryData[this.new_risk_category].values);
          this.calculateMax();
          this.processData();
        }
      });
  }
  ngOnChanges(change) {
    console.log('change123', change);
    if (change['investor'] && change['investor'].currentValue) {
      if (!change['investor'].previousValue) {
        this.processData();
        console.log('change123', 'changing1');
      } else {
        if (
          JSON.stringify(change['investor'].previousValue) !=
          JSON.stringify(change['investor'].currentValue)
        ) {
          this.processData();
          console.log('change123', 'changing2');
        }
      }
    }
    if (
      change['new_risk_category'] &&
      change['new_risk_category'].currentValue
    ) {
      if (!change['new_risk_category'].previousValue) {
        this.loadCategoryData();
      } else {
        if (
          JSON.stringify(change['new_risk_category'].previousValue) !=
          JSON.stringify(change['new_risk_category'].currentValue)
        ) {
          this.loadCategoryData();
        }
      }
    }
    if (
      change['category'] &&
      change['category'].currentValue
    ) {
      if (!change['category'].previousValue) {
        this.loadCategoryData();
      } else {
        if (
          JSON.stringify(change['category'].previousValue) !=
          JSON.stringify(change['category'].currentValue)
        ) {
          this.loadCategoryData();
        }
      }
    }
  }

  getPercentageForItem(item) {
    // if(item.showAmounts){
    //   console.log(console.log(item.name, this._total, item.count));
    // }
    // console.log(item);
    if (!item) {
      return 0;
    }
    return Math.round((item.count / this._total) * 100) || 0;
  }

  sliderChange() {
    console.log('changingevent', event);
    if (this.suggestionData && this.suggestionData["unallocated"] != 0) {
      this.suggestionData["unallocated"] = 0;
    }

    this.suggestionTotal = Object.keys(this.suggestionData).sort().reduce((accumulator, currentItem) => {
      return accumulator + this.suggestionData[currentItem];
    }, 0);

    this.currentReturn = Object.keys(this.suggestionData).sort().reduce((accumulator, currentItem, index) => {
      if (currentItem == "unallocated") {
        return accumulator;
      }
      console.log(this.assetGroups, this.assetGroups[index], currentItem);
      return accumulator + (this.suggestionData[currentItem] * this.assetGroups[index].returns);
    }, 0) * 0.01;
    console.log("citem", this.currentReturn);

    if (this.suggestionTotal < 100) {
      this.suggestionData['unallocated'] = 100 - this.suggestionTotal;
    } else {
      this.suggestionData['unallocated'] = 0;
    }
    this.calculateMax();
    // this.advisorChart.destroy();
    this.advisorChartData = Object.keys(this.suggestionData).sort().map((item, index) => {
      var color = 'white'
      if (item != 'unallocated') {
        color = this.assetGroups[index]["color"] || 'white';
      }
      return new DoughnutChartItem(item, this.suggestionData[item], color, 0);
    });

    // if(this.suggestionTotal<100) {
    //   advisorChartData.push(new DoughnutChartItem("Unallocated", 100-this.suggestionTotal, 'white', 0));
    // }

    // this.advisorChartData = advisorChartData;

  }

  loadCategoryData() {
    switch (this.category) {
      case "basic":
        this.categoryData = this.basic;
        break;
      case "standard":
        this.categoryData = this.standard;
        break;
      case "premium":
        this.categoryData = this.premium;
        break;
      default:
        this.categoryData = this.basic;
        break;
    }
    if (this.categoryData) {
      Object.assign(this.suggestionData, this.categoryData[this.new_risk_category].values);
    }
    // Object.assign(this.suggestionData, this.categoryData[this.new_risk_category].values);
  }

  allowedSlack(category) {
    switch (category) {
      case "basic":
        return 10;
      case "standard":
        return 20;
      case "premium":
        return 30;
      default:
        return 10;
    }
  }
  calculateMin(group) {
    const minValue = this.categoryData[this.new_risk_category].values[group] - this.allowedSlack(this.category);
    if (minValue <= 0) {
      return 0
    }
    return minValue;
  }
  calculateMax() {
    if (!this.categoryData) {
      return;
    }
    Object.keys(this.suggestionData).forEach(group => {

      const midPoint = this.categoryData[this.new_risk_category].values[group];
      this.suggestionTotal;
      const currentValue = this.suggestionData[group];
      const slack = 100 - this.suggestionTotal;
      var maxValue = (midPoint + this.allowedSlack(this.category)) <= (currentValue + slack) ? (midPoint + this.allowedSlack(this.category)) : (currentValue + slack);
      if (maxValue >= 100) {
        this.maxValues[group] = 100
      } else {
        this.maxValues[group] = maxValue;
      }
    })
  }

  saveSuggestion() {
    if (confirm("Are you sure you want to save the suggestion?")) {
      var newSuggestion: Suggestion = {
        risk_category: this.new_risk_category,
        category: this.category,
        allocationData: { ...this.suggestionData },
      }
      // newSuggestion.iid = this.investor.iid;
      // newSuggestion.risk_category = this.new_risk_category;
      // newSuggestion.allocationData = this.suggestionData;
      this.__suggestionService.addSuggestionData(newSuggestion, this.investor);
    }
  }

  generateChartData(riskCategory) {
    console.log('newlog123', riskCategory, this.categoryData);
    if (!this.categoryData) {
      return;
    }
    const values = this.categoryData[riskCategory].values;
    const chartdata = Object.keys(this.categoryData[riskCategory].values).sort().map((item, index) => {
      console.log('diffrence', this.assetGroups[index], item);
      return new DoughnutChartItem(item, values[item], this.assetGroups[index]["color"], 0);
    });
    console.log("riskabc", riskCategory, chartdata);
    return chartdata;
  }

  processData() {
    // this.investor = investor;
    console.log('hello', this.investor);
    // return;
    const assetAllocationGroups = groupBy(
      this.investor.assets,
      'asset_allocation_type',
    );

    this.loadCategoryData()
    this.selectedChartData = this.generateChartData(this.new_risk_category);
    this.chartData = availableGroupings.map((group) => {
      console.log(group);
      const assets = assetAllocationGroups[group.group] || [];

      const assetsTotal =
        assets
          .map((a) => parseInt(a.value) || 0)
          .reduce((val1, val2) => val1 + val2, 0) || 0;
      const assetsReturns =
        assets
          .map((a) => a.return_percentage)
          .reduce((val1, val2) => val1 + val2, 0) || 0;
      return new DoughnutChartItem(
        group.name,
        assetsTotal,
        group.color,
        assetsReturns,
      );
    });
    this._total = this.chartData.reduce((total, item) => {
      console.log(item);
      total = total + item.count;
      // this.chartData["percent"] = total + item.count;
      // return (item.count/total)*100;
      return total;
    }, 0);
    console.log('hello', this._total);
    this.sliderChange();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/reports/suggest/suggest.component.ts